<template>
  <transition name="accordion"
    @before-enter="beforeEnter" @enter="enter"
    @before-leave="beforeLeave" @leave="leave"
  >
    <slot />
  </transition>
</template>

<script>
// TODO: el.scrollHeight still causes problems when v-img are used
// TODO: this can't be nested as only static heights work
  export default {
    methods: {
      beforeEnter: function(el) {
        el.style.height = '0';
        this.$emit('nested-beforeEnter');
      },
      enter: function(el) {
        this.$nextTick(function() {
          el.style.height = el.scrollHeight + 'px';
        });
        this.$emit('nested-enter');
      },
      beforeLeave: function(el) {
        el.style.height = el.scrollHeight + 'px';
        this.$emit('nested-beforeLeave');
      },
      leave: function(el) {
        el.style.height = '0';
        this.$emit('nested-leave');
      },
    },
  }
</script>

<style>
  .accordion-enter-active, .accordion-leave-active {
    transition: all .25s ease-out;
    overflow: hidden;
  }
  .accordion-enter, .accordion-leave-to {
    opacity: 0;
    transform-origin: top center;
    overflow: hidden;
  }
</style>
